import React from 'react';
import type { FC } from 'react';
import { SelectInput } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import type { DeveloperApp } from '@wix/dev-center-client';
import type { AppData } from '../types.js';
import { useCreateAppBi } from '../bi/index.js';

interface ExtendExistingAppProps {
  developerApps: DeveloperApp[];
  onSelected: (options: AppData) => void;
}

export const ExtendExistingApp: FC<ExtendExistingAppProps> = ({
  developerApps,
  onSelected,
}) => {
  const { t } = useTranslation();
  const { cliFlowStepAnswered } = useCreateAppBi();

  return (
    <SelectInput
      label={t('create_app.extend_existing.select_app.label')}
      limit={5}
      onSubmit={({ value: appId, title: appName }) => {
        cliFlowStepAnswered({
          question: t('create_app.extend_existing.select_app.label'),
          questionKey: 'create_app.extend_existing.select_app.label',
          answer: appName,
          additionalInfo: {
            numApps: developerApps.length,
            appId,
          },
        });

        onSelected({ appId, appName });
      }}
      options={developerApps.map((developerApp) => {
        return {
          title: developerApp.appData.appName,
          value: developerApp.id,
        };
      })}
    />
  );
};
